import { getApiBaseURL } from "../services/api";

export const ADMIN_TOKEN_KEY = "cu_navbot_admin_token";

export function getAdminToken() {
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAdminToken(token) {
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken() {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
}

export async function fetchAdminAuthStatus() {
  const res = await fetch(`${getApiBaseURL()}/auth/admin/status`);
  if (!res.ok) throw new Error("Failed to check admin auth status");
  return res.json();
}

export async function verifyAdminToken(token) {
  const res = await fetch(`${getApiBaseURL()}/auth/admin/verify`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.ok;
}

export async function loginAdmin(username, password) {
  const res = await fetch(`${getApiBaseURL()}/auth/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.detail || "Login failed");
  }
  return data;
}

export function adminLoginUrl(nextPath) {
  const next = nextPath || "/admin";
  return `/admin/login?next=${encodeURIComponent(next)}`;
}
